module.exports = __webpack_public_path__ + "img/inverter_color.70d515f8.png";